import { render, staticRenderFns } from "./BaseCarouselNavigation.vue?vue&type=template&id=6f0d28fa"
import script from "./BaseCarouselNavigation.vue?vue&type=script&lang=js"
export * from "./BaseCarouselNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports